export const siteCopy = {
  pt: {
    nav: {
      work: 'Projetos',
      about: 'Sobre',
      contact: 'Contacto',
      language: 'PT',
      languageShort: 'EN',
      toggleLabel: 'Mudar para inglês',
    },
    footer: {
      tagline: 'Designer gráfica · Porto, Portugal',
      copyright: 'Todos os direitos reservados.',
    },
    home: {
      label: 'Designer gráfica – Porto, Portugal',
      title: 'Designer gráfica focada em editorial, identidade visual, cartaz, motion, publicidade e design de interação.',
      subtitle: 'Experiência em projetos académicos e freelance, desenvolvidos individualmente e em colaboração com equipa.',
      emailAria: 'Enviar email',
      socialAria: 'Instagram',
      introNote: 'Aberta a oportunidades de estágio, trabalho para empresas e projetos freelance.',
    },
    about: {
      title: 'Augusta Silva',
      role: 'Designer gráfica',
      intro1: 'Designer com experiência no desenvolvimento de projetos criativos, com facilidade de adaptação a diferentes desafios.',
      intro2: 'Com formação em Design de Comunicação, desenvolvi projetos nos campos de design editorial, identidade visual, publicidade, motion e design de interação.',
      educationTitle: 'Formação',
      experienceTitle: 'Experiência',
      interdisciplinaryTitle: 'Projetos Interdisciplinares',
      cta: 'Ver projetos →',
      locationTitle: 'Localização',
      emailTitle: 'Email',
      phoneTitle: 'Número',
      socialsTitle: 'Redes Sociais',
      workAreasTitle: 'Áreas de Trabalho',
    },
    contact: {
      title: 'Contacto',
      intro: 'Aberta a oportunidades de estágio, trabalho para empresas e projetos freelance.',
      emailTitle: 'Email',
      phoneTitle: 'Número',
      socialsTitle: 'Redes Sociais',
      locationTitle: 'Localização',
      formTitle: 'Enviar mensagem',
      nameLabel: 'Nome',
      emailLabel: 'Email',
      messageLabel: 'Mensagem',
      namePlaceholder: 'O seu nome',
      emailPlaceholder: 'seu.email@exemplo.com',
      messagePlaceholder: 'A sua mensagem...',
      submit: 'Enviar mensagem',
      success: 'Mensagem pronta para envio no seu cliente de email.',
      reset: 'Escrever outra mensagem',
    },
    projectPage: {
      summary: 'Resumo',
      objectives: 'Objetivos',
      process: 'Processo',
      finalOutput: 'Produto Final',
      extra: 'Extra',
      video: 'Ver vídeo',
      credits: 'Créditos',
      previous: '← Projeto anterior',
      next: 'Próximo projeto →',
      back: 'Voltar aos projetos',
      technologies: 'Tecnologias usadas',
      notePyrenees: 'Este cartaz utiliza realidade aumentada através da aplicação Artivive.',
      noteMae: 'Instalação interativa controlada através de comando Xbox.',
    },
  },
  en: {
    nav: {
      work: 'Work',
      about: 'About',
      contact: 'Contact',
      language: 'EN',
      languageShort: 'PT',
      toggleLabel: 'Switch to Portuguese',
    },
    footer: {
      tagline: 'Graphic designer · Porto, Portugal',
      copyright: 'All rights reserved.',
    },
    home: {
      label: 'Graphic designer – Porto, Portugal',
      title: 'Graphic designer focused on editorial, visual identity, poster design, motion, advertising, and interaction design.',
      subtitle: 'Experience in academic and freelance projects, developed individually and in collaboration with teams.',
      emailAria: 'Send email',
      socialAria: 'Instagram',
      introNote: 'Open to internships, work for companies, and freelance projects.',
    },
    about: {
      title: 'Augusta Silva',
      role: 'Graphic designer',
      intro1: 'Designer with experience in creative project development and a strong ability to adapt to different challenges.',
      intro2: 'With a background in Communication Design, I have developed projects in editorial design, visual identity, advertising, motion, and interaction design.',
      educationTitle: 'Education',
      experienceTitle: 'Experience',
      interdisciplinaryTitle: 'Interdisciplinary Projects',
      cta: 'View projects →',
      locationTitle: 'Location',
      emailTitle: 'Email',
      phoneTitle: 'Number',
      socialsTitle: 'Social Media',
      workAreasTitle: 'Work Areas',
    },
    contact: {
      title: 'Contact',
      intro: 'Open to internships, work for companies, and freelance projects.',
      emailTitle: 'Email',
      phoneTitle: 'Number',
      socialsTitle: 'Social Media',
      locationTitle: 'Location',
      formTitle: 'Send a message',
      nameLabel: 'Name',
      emailLabel: 'Email',
      messageLabel: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your.email@example.com',
      messagePlaceholder: 'Your message...',
      submit: 'Send message',
      success: 'Message ready to send in your email client.',
      reset: 'Write another message',
    },
    projectPage: {
      summary: 'Summary',
      objectives: 'Objectives',
      process: 'Process',
      finalOutput: 'Final Output',
      extra: 'Extra',
      video: 'Watch video',
      credits: 'Credits',
      previous: '← Previous project',
      next: 'Next project →',
      back: 'Back to projects',
      technologies: 'Technologies used',
      notePyrenees: 'This poster uses augmented reality through the Artivive app.',
      noteMae: 'Interactive installation controlled with an Xbox controller.',
    },
  },
};

export const getCopy = (language) => siteCopy[language] || siteCopy.pt;
